/**
 * CTR Scent Selector – Product-swap scent picker (CTR)
 *
 * Fetches Shopify Section Rendering API HTML (`?sections=`) and replaces
 * only product media / info blocks in place (no viewTransition double-buffer).
 */
(function () {
  if (window.__ctrScentSelectorInit) return;
  window.__ctrScentSelectorInit = true;

  var htmlCache = {};
  var inflightFetches = {};
  var swapGeneration = 0;

  function normalizeUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname + parsed.search;
    } catch (e) {
      return url;
    }
  }

  function buildSectionsRenderUrl(productUrl, sectionId) {
    var url = new URL(productUrl, window.location.origin);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', sectionId);
    return url.pathname + url.search;
  }

  function fetchProductSectionHtml(productUrl, sectionId) {
    var requestUrl = buildSectionsRenderUrl(productUrl, sectionId);
    var key = normalizeUrl(requestUrl);
    if (htmlCache[key]) return Promise.resolve(htmlCache[key]);
    if (inflightFetches[key]) return inflightFetches[key];

    var request = fetch(requestUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Scent fetch failed: ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var html = data && data[sectionId];
        if (!html) throw new Error('Rendered section missing: ' + sectionId);
        htmlCache[key] = html;
        delete inflightFetches[key];
        return html;
      })
      .catch(function (err) {
        delete inflightFetches[key];
        throw err;
      });

    inflightFetches[key] = request;
    return request;
  }

  function prefetchScent(card) {
    if (!card) return;
    var url = card.dataset.productUrl || card.getAttribute('href');
    var sectionId = getActiveSectionId(card);
    if (!url || !sectionId || card.classList.contains('is-active')) return;
    fetchProductSectionHtml(url, sectionId).catch(function () {});
  }

  function prefetchAllScents() {
    document.querySelectorAll('[data-ctr-scent-card]').forEach(prefetchScent);
  }

  function setActivePill(card) {
    var selector = card && card.closest('[data-ctr-scent-selector]');
    var root = selector || document;
    root.querySelectorAll('[data-ctr-scent-card]').forEach(function (el) {
      var active = el === card;
      el.classList.toggle('is-active', active);
      if (active) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
      el.style.opacity = '';
      el.style.pointerEvents = '';
    });
  }

  function getActiveSectionId(card) {
    var selector = card && card.closest('[data-ctr-scent-selector]');
    if (selector && selector.dataset.sectionId) return selector.dataset.sectionId;

    var productInfo = document.querySelector('product-info[data-section]');
    if (productInfo) return productInfo.getAttribute('data-section');

    return '';
  }

  function loadMissingScripts(rootNode) {
    var newScripts = rootNode.querySelectorAll('script[src]');
    if (!newScripts.length) return Promise.resolve();

    var existingSrcs = {};
    document.querySelectorAll('script[src]').forEach(function (s) {
      existingSrcs[s.src] = true;
    });

    var promises = [];
    newScripts.forEach(function (tag) {
      var a = document.createElement('a');
      a.href = tag.getAttribute('src');
      var absoluteSrc = a.href;

      if (existingSrcs[absoluteSrc]) return;

      promises.push(
        new Promise(function (resolve) {
          var script = document.createElement('script');
          script.src = absoluteSrc;
          script.onload = resolve;
          script.onerror = function () {
            console.warn('[ctr-scent-selector] Failed to load script:', absoluteSrc);
            resolve();
          };
          document.head.appendChild(script);
        })
      );
    });

    return Promise.all(promises);
  }

  /**
   * Replace a node in place. Avoids HTMLUpdateUtility.viewTransition, which
   * temporarily inserts BOTH old+new nodes and removes the old one 500ms later
   * (that height flicker is what causes the page to jump).
   */
  function replaceNodeInPlace(oldNode, newContent) {
    if (!oldNode || !newContent) return null;

    var wrapper = document.createElement('div');
    if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility.setInnerHTML) {
      HTMLUpdateUtility.setInnerHTML(wrapper, newContent.outerHTML);
    } else {
      wrapper.innerHTML = newContent.outerHTML;
    }

    var newNode = wrapper.firstElementChild;
    if (!newNode) return null;

    oldNode.replaceWith(newNode);
    return newNode;
  }

  function getScrollAnchorTop() {
    var selector = document.querySelector('[data-ctr-scent-selector]');
    if (selector) return selector.getBoundingClientRect().top;

    var info = document.querySelector('#product-info');
    if (info) return info.getBoundingClientRect().top;

    return null;
  }

  function restoreScrollAnchor(anchorTop) {
    if (anchorTop == null) return;

    function apply() {
      var currentTop = getScrollAnchorTop();
      if (currentTop == null) return;
      var delta = currentTop - anchorTop;
      if (Math.abs(delta) > 1) {
        window.scrollBy(0, delta);
      }
    }

    apply();
    window.requestAnimationFrame(apply);
    window.setTimeout(apply, 0);
    window.setTimeout(apply, 50);
  }

  function runPostSwapInit() {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }

    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
    if (window.ProductModel) {
      window.ProductModel.loadShopifyXR();
    }
    if (typeof window.initSimpleCtrBuyButtons === 'function') {
      window.initSimpleCtrBuyButtons(document);
    }
    if (typeof window.initCtrFaqAccordions === 'function') {
      window.initCtrFaqAccordions(document);
    }
    prefetchAllScents();
  }

  function applySwap(responseText, productUrl, generation, anchorTop) {
    if (generation !== swapGeneration) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = responseText;

    var newProductInfo = wrapper.querySelector('product-info');
    var newSticky = wrapper.querySelector('#shopify-section-sticky-atc-bar, sticky-atc-bar, sticky-atc-bar-minimalist, .sticky-atc-bar');

    return loadMissingScripts(wrapper).then(function () {
      if (generation !== swapGeneration) return;

      var oldProductInfo = document.querySelector('product-info[data-section]');
      if (oldProductInfo && newProductInfo) {
        Array.from(newProductInfo.attributes).forEach(function (attribute) {
          oldProductInfo.setAttribute(attribute.name, attribute.value);
        });

        var oldMedia = oldProductInfo.querySelector('.product__media-wrapper');
        var newMedia = newProductInfo.querySelector('.product__media-wrapper');
        if (oldMedia && newMedia) replaceNodeInPlace(oldMedia, newMedia);

        var oldInfo = oldProductInfo.querySelector('#product-info');
        var newInfo = newProductInfo.querySelector('#product-info');
        if (oldInfo && newInfo) replaceNodeInPlace(oldInfo, newInfo);

        var oldRecentlyViewed = oldProductInfo.querySelector('product-recently-viewed');
        var newRecentlyViewed = newProductInfo.querySelector('product-recently-viewed');
        if (oldRecentlyViewed && newRecentlyViewed) {
          replaceNodeInPlace(oldRecentlyViewed, newRecentlyViewed);
        }
      }

      var oldSticky = document.getElementById('shopify-section-sticky-atc-bar')
        || document.querySelector('sticky-atc-bar, sticky-atc-bar-minimalist, .sticky-atc-bar');
      if (oldSticky && newSticky) replaceNodeInPlace(oldSticky, newSticky);

      window.history.replaceState({}, '', productUrl);
      runPostSwapInit();
      restoreScrollAnchor(anchorTop);
    });
  }

  function swapToProduct(productUrl, card) {
    if (!productUrl) return;

    var generation = ++swapGeneration;
    var sectionId = getActiveSectionId(card);
    if (!sectionId) return;

    var anchorTop = getScrollAnchorTop();

    if (card) setActivePill(card);
    if (card && typeof card.blur === 'function') card.blur();

    fetchProductSectionHtml(productUrl, sectionId)
      .then(function (responseText) {
        return applySwap(responseText, productUrl, generation, anchorTop);
      })
      .catch(function (err) {
        if (generation !== swapGeneration) return;
        console.error('[ctr-scent-selector] Product fetch failed:', err);
        if (card) {
          card.style.opacity = '';
          card.style.pointerEvents = '';
        }
      });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-ctr-scent-card]');
    if (!card) return;

    if (card.classList.contains('is-active')) {
      e.preventDefault();
      return;
    }

    e.preventDefault();

    var productUrl = card.dataset.productUrl || card.getAttribute('href');
    swapToProduct(productUrl, card);
  });

  document.addEventListener(
    'pointerenter',
    function (e) {
      var card = e.target.closest && e.target.closest('[data-ctr-scent-card]');
      if (card) prefetchScent(card);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (e) {
      var card = e.target.closest && e.target.closest('[data-ctr-scent-card]');
      if (card) prefetchScent(card);
    },
    true
  );

  function schedulePrefetch() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(prefetchAllScents, { timeout: 1500 });
    } else {
      setTimeout(prefetchAllScents, 400);
    }
  }

  document.addEventListener('DOMContentLoaded', schedulePrefetch);
  window.addEventListener('pageshow', schedulePrefetch);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', schedulePrefetch);
  }
})();
